import React from 'react';
import { __t } from '../../../base/utils/t';
import { VacancyCard } from '../../../employer/units/vacancy/components/VacancyCard';
import { SimilarVacancy } from '../../units/vacancies/api/interfaces';

import './styles.scss';
import { quickApplyActions } from '../../units/quick-apply/redux/slices/quickApplySlice';
import { useAppDispatch } from '../../../base/hooks';

interface Props {
    similarVacancies: SimilarVacancy[];
}

export const RecommendedVacancies = ({ similarVacancies }: Props) => {
    const dispatch = useAppDispatch();

    const favoritesClickHandler = (vacancyId: number, isFavorite: boolean) =>
        dispatch(quickApplyActions.similarVacanciesFavoritesToggleRequest(vacancyId, isFavorite));

    return (
        <div className='recommended-vacancies'>
            <h3 className='recommended-vacancies__title'>{__t('Похожие вакансии')}</h3>

            <div className='recommended-vacancies__wrap'>
                {similarVacancies.map((vacancy) => (
                    <VacancyCard key={vacancy.id} {...vacancy} onFavoritesClick={favoritesClickHandler} />
                ))}
            </div>
        </div>
    );
};
